import { FEATURE_FLAGS } from "../contexts/FeatureFlagsProvider";
import { useWeekIndex } from "../contexts/WeekIndexProvider";
import { useFeatureFlag } from "./useOpenFeatureFlag";

/**
 * View-level week-start day (0=Sun..6=Sat) for the staff-app weekly views.
 *
 * Returns the shared `viewStartDay` (same source of truth as Staffing/Profile/Master Schedule)
 * when `StaffingDynamicWeekStart` is on, otherwise 0 (Sunday). Returning 0 when the flag is off
 * keeps mobile byte-for-byte identical to the legacy Luxon `startOf("week")` behavior — Luxon's
 * global `firstDay` is pinned to Sunday, so `getWeekStart(d, 0)` === `d.startOf("week")`.
 */
export const useEffectiveWeekStartDay = (): number => {
	const isDynamicWeekStartEnabled = useFeatureFlag(FEATURE_FLAGS.StaffingDynamicWeekStart);
	const { viewStartDay } = useWeekIndex();
	return isDynamicWeekStartEnabled ? viewStartDay : 0;
};
